import type { ProductItem } from './types';

/**
 * Pick the parents whose full reorder rows must be fetched again after the product list was
 * replaced: those the user still has expanded, that are on the fresh page, and that the (just
 * emptied) cache does not hold. Parents that left the list — archived, trashed, or now standalone
 * with no cluster — are skipped rather than fetched for nothing.
 * @param products the freshly loaded product page
 * @param expandedIds parent ids whose cluster is currently expanded in the grid
 * @param cached the reorder cache, keyed by parent id
 * @returns the parent ids to re-fetch, in list order
 */
export const parentsToRewarm = (products: ProductItem[], expandedIds: ReadonlySet<string>, cached: Record<string, unknown>): string[] =>
  products.map((product) => String(product._id)).filter((id) => expandedIds.has(id) && !(id in cached));
